__turbopack_context__.v({
  "ghost": "PaperGhost-module__wxzGNq__ghost",
});
